import { elementOpen, elementClose, text, patch } from 'incremental-dom';
import './footer.scss';
import { linkClick } from '../../rxjs';
import { ContactType } from '../../enums';
import { createElement } from '../../incdom';
var address = function (FooterAddress) {
    elementOpen('div', null, null, 'class', 'footer-address');
    FooterAddress.map(function (c) {
        switch (c.type) {
            case ContactType.Mail:
                contactMaillLink(c.icon, c.label, 'mailto:' + c.target);
                break;
            case ContactType.Line:
                contactLine(c.icon, c.label);
                break;
            case ContactType.Link:
                contactLineLink(c.icon, c.label, c.target);
                break;
            case ContactType.External:
                contactExternalLink(c.icon, c.label, c.target);
                break;
            default:
                console.log('Internal error: Unknown contact type');
        }
        ;
    });
    // elementOpen('a', null, null,
    //     'href', '/contact',
    //     'onclick', (event) => linkClick(event, '/contact'));
    //     contactLine(locationIcon, 'Guildford');
    // elementClose('a');
    // elementOpen('p');
    //     text('We are located in central Guildford, Surrey, UK');
    // elementClose('p');
    // elementOpen('a', null, null,
    // 'href', '/contact',
    // 'onclick', (event) => linkClick(event, '/contact'));
    //     contactLine(mailIcon, 'Contact Us');
    // elementClose('a');
    elementClose('div');
};
var contacts = function (FooterContacts) {
    elementOpen('div', null, null, 'class', 'footer-contacts');
    // contactLineLink(worldIcon, 'www.appzuka.io', '/');
    // contactMaillLink(emailIcon, 'info@appzuka.io', 'mailto:info@appzuka.io');
    // contactLine(phoneIcon, '+44 7789 928955');
    // contactExternalLink(linkedinIcon, 'linkedin', 'https://www.linkedin.com/in/nickexcell/');
    FooterContacts.map(function (c) {
        switch (c.type) {
            case ContactType.Mail:
                contactMaillLink(c.icon, c.label, 'mailto:' + c.target);
                break;
            case ContactType.Line:
                contactLine(c.icon, c.label);
                break;
            case ContactType.Link:
                contactLineLink(c.icon, c.label, c.target);
                break;
            case ContactType.External:
                contactExternalLink(c.icon, c.label, c.target);
                break;
            default:
                console.log('Internal error: Unknown contact type');
        }
        ;
    });
    elementClose('div');
};
var contactExternalLink = function (icon, label, link) {
    elementOpen('a', null, null, 'href', link, 'target', '_blank', 'rel', 'nofollow noopener noreferrer');
    contactLine(icon, label);
    elementClose('a');
};
var contactMaillLink = function (icon, label, link) {
    elementOpen('a', null, null, 'href', link);
    contactLine(icon, label);
    elementClose('a');
};
var contactLineLink = function (icon, label, link) {
    elementOpen('a', null, null, 'href', link, 'onclick', function (event) { return linkClick(event, link); });
    contactLine(icon, label);
    elementClose('a');
};
var internalLink = function (label, link) {
    elementOpen('a', null, null, 'href', link, 'onclick', function (event) { return linkClick(event, link); });
    text(label);
    elementClose('a');
};
var showVersionTime = 0;
var clickCommit = function (e) {
    e.preventDefault();
    var clickInterval = Date.now() - showVersionTime;
    if ((clickInterval > 500) && (clickInterval < 3000)) {
        var el_1 = document.getElementById('footer-versions');
        el_1.style.display = 'block';
        window.scrollTo(0, document.body.scrollHeight);
        setTimeout(function () { el_1.style.display = 'none'; }, 15000); // No need to cancel as the footer is always in the DOM
    }
    showVersionTime = Date.now();
};
var copyright = function (commit, year) {
    createElement("render", null,
        createElement("p", null,
            createElement("span", { onclick: function (e) { return clickCommit(e); } }, commit),
            " \u00A9 Copyright ",
            year,
            " by",
            createElement("a", { href: 'https://www.appzuka.io', target: '_blank', rel: 'nofollow noopener noreferrer' }, " appZuka "),
            "All Rights Reserved."));
};
var contactLine = function (icon, label) {
    elementOpen('div', null, null, 'class', 'footer-contact-line');
    if (icon !== undefined) {
        icon();
    }
    elementOpen('p');
    text(label);
    elementClose('p');
    elementClose('div');
};
// NICE: Expose the address and contact functions and allow a variable number of blocks so this is more flexible
var insertFooter = function (FooterContacts, FooterAddress, FooterSiteLogo, commitVersion, buildDate, versionList, options) {
    var policyList = options.policies || [
        { label: 'Website Terms', link: '/policies/terms' },
        { label: 'Privacy Policy', link: '/policies/privacy' },
    ];
    var footerWrapper = document.getElementById('footerwrapper');
    // TODO: Delay until after page rendered
    patch(footerWrapper, function () {
        elementOpen('div', null, null, 'class', 'footer-content');
        elementOpen('a', null, ['class', 'footer-logo-link'], 'href', '/', 'onclick', function (event) { return linkClick(event, '/'); });
        FooterSiteLogo();
        elementClose('a');
        address(FooterAddress);
        contacts(FooterContacts);
        elementClose('div');
        elementOpen('div', null, null, 'class', 'footer-copyright-wrapper');
        elementOpen('div', null, null, 'class', 'footer-copyright');
        elementOpen('div', null, null, 'class', 'terms-links');
        elementOpen('ul');
        policyList.map(function (p) {
            elementOpen('li');
            internalLink(p.label, p.link);
            elementClose('li');
        });
        elementClose('ul');
        elementClose('div');
        elementOpen('div', null, null, 'class', 'terms-copyright');
        copyright(commitVersion + " " + buildDate, options.copyrightYear || '2021');
        elementClose('div');
        elementClose('div');
        elementOpen('div', null, null, 'id', 'footer-versions', 'style');
        elementOpen('ul');
        versionList.map(function (v) {
            elementOpen('li');
            elementOpen('p');
            text(v);
            elementClose('p');
            elementClose('li');
        });
        elementClose('ul');
        elementClose('div');
        elementClose('div');
    });
    // window.innerHeight will change if the page scrolls on mobile and the tab bar disaappears, but this just sets the min
    // height for short pages so there will be always be a scroll bar (to prevent width jumps)
    var mainContainer2 = document.getElementById('container');
    mainContainer2.style.minHeight = "calc(" + (window.innerHeight + 2) + "px - " + footerWrapper.offsetHeight + "px)";
};
export { insertFooter };
//# sourceMappingURL=index.js.map